"use strict";
// Globals
var height, width;

var sourceImageData;
var meters;

var channels = 4;
var foundAreas = [];


var localContrastW = 14;
var minimumSize = 60;
var maximumSize =  400;


var imgData; // Array of image data

var eliminatedPixels = [];
var eliminatedInvertedPixels = [];
//var areaX = 100;
var areaX = 0;
var areaY = 0;
//var areaY = 40;
var areaW = 640; // 400
var areaH = 480; // 150

var debugDiv = null;

var pixels = null;

var canvas = null;
var context = null;

function prepareAnalyzing(div, img){
	debugDiv = div;
	var divWidth = div.clientWidth;
	var divHeight = div.clientHeight;
	// Image received - fetch some measurements
	width = img.width;
	height = img.height;
	canvas = document.createElement('canvas');
	canvas.width  = width;
	canvas.height = height;
	canvas.style.width = divWidth;
	canvas.style.height = divHeight;

	context = canvas.getContext("2d");
	context.drawImage(img, 0, 0);
	sourceImageData = context.getImageData(0, 0, width, height);
	imgData = sourceImageData.data;
}

exports.analyzeImage= function (pixels,config,cb) {

	if (!pixels) return false;
	// Pixel data received - fetch some measurements
	if (pixels.shape) {
		width = pixels.shape[0];
		height = pixels.shape[1];
	}
	areaW = width; // 400
	areaH = height; // 150

	if(!config) config = {};

	var	redTreshold = config.decimals.redTreshold || 10;
	var minimumSize = config.decimals.minimumPotentiometerSize || 100;
	var maximumSize =  config.decimals.maximumPotentiometerSize || 200;
	var redTargetPercentage = config.decimals.redTargetPercentage || null;
	var luminanceThreshold = config.decimals.luminanceThreshold || 210;

	channels = 4;

	// Clear arrays
	meters = [];
	foundAreas = [];

	// if we are in browser environment, create canvas for debug purpose
	canvas = null;
	context = null;
	if(typeof document === 'object' && !canvas){
		canvas = document.createElement('canvas');
		canvas.width  = width;
		canvas.height = height;
		//canvas.style.width = divWidth;
		//canvas.style.height = divHeight;
		context = canvas.getContext("2d");
		sourceImageData = context.createImageData(width, height); // width x height
		var data = sourceImageData.data;
		// copy pixels byte-per-byte into canvas ImgData
		for (var i = 0, len = width * height * channels; i < len; i++) {
    		data[i] = pixels.data[i];
		}
		imgData = sourceImageData.data;
		// draw original source to canvas
		context.putImageData(sourceImageData,0,0);
	}
	else if (pixels.data){
		imgData = pixels.data;
	}

	if(redTargetPercentage){
		var redAmount = getRedAmount(redTreshold);
		var redTargetAmount = (width * height * redTargetPercentage)/100;

		if(redTargetAmount > redAmount){
			while(redTargetAmount > redAmount && redTreshold > 0){
				redTreshold -=1;
				redAmount = getRedAmount(redTreshold);
			}
		}
		else{
			while(redTargetAmount < redAmount && redTreshold <= 255){
				redTreshold +=1;
				redAmount = getRedAmount(redTreshold);
			}
		}
	}

	var redAmount = separateRed(redTreshold);
	var redPercentage = (redAmount / (width * height)) * 100;
	calculateLuminance();
	//localContrastNormalization(localContrastW);
	separateLuminance(luminanceThreshold);

	//console.log ("Red percentage : "+redPercentage);
	findObjects(minimumSize, maximumSize, 1.3);

	if(canvas){
		context.imageSmoothingEnabled = false;
		context.globalAlpha = 1;
		drawRedPixels();
		drawBlackPixels();
		drawMeters(meters);
	}

	meters.sort(function(a, b){ // Sorts meters from bottom to top
		var y1 = a.center.y, y2 = b.center.y;
		if (y2 > y1) return 1;
		if (y2 < y1) return -1;
		return 0;
		}
	);

	//draw values hangs in mac nodejs
	//drawValues(2); // Rounding to 2 digits
	//console.log("found objects : " +meters.length);


	if (debugDiv && canvas) debugDiv.appendChild(canvas);

	if (meters.length === 2){
	// Start raymarching
		for (var i = 0; i < meters.length; i++){
			var rays = createRays(meters[i].center, 60);
			for (var r = 0; r < rays.length; r++){
				rays[r].distance = getRayDistance(rays[r], 30, 60);
			}
			//console.log(rays);
			var result = angleToValue(getAverageAngle(rays));
			meters[i].value = result;
			//var result = angleToValue(getLongestRayAngle(rays));
			//console.log("Result : " + result);
		}
	}

	// just simulate async callback
	if (cb) setTimeout(function(){
		// callback does currently newer send error object
		cb(null,{ meters:meters,redPercentage:redPercentage, canvas:canvas, redTreshold:redTreshold});
	},0);
	else{
		return { meters: meters, canvas:canvas};
	}

}

function getLongestRayAngle(rays){
	if(rays.length == 0) return 0;
	var l = 0;
	var index = 0;
	for (var i = 0; i < rays.length; i++){
		if (rays[i].distance > l) {
			index = i;
			l = rays[i].distance;
		}
	}
	if(rays.length == 0) return -1;
	var resultRay = rays[index];
	if (canvas){
		context.fillStyle = "yellow";
		context.fillRect(resultRay.start.x - 4, resultRay.start.y - 4, 8, 8);
		context.fillStyle = "pink";
		context.fillRect(resultRay.end.x - 4, resultRay.end.y - 4, 8, 8);
	}
	return Math.atan2(resultRay.end.y - resultRay.start.y, resultRay.end.x - resultRay.start.x) * (180 / Math.PI) + 90; // We add 90 to translate to positive Y-axis from X-axis.

}


function getAverageAngle(rays){
	if(rays.length < 10) return -1;
	var total = 0;
	for (var i = 0; i < rays.length; i++){
		total += rays[i].distance;
	}
	var average = total / rays.length;
	//console.log("average " + average);
	for (var i = 0; i < rays.length; i++){
		if (rays[i].distance < average + 30) { rays.splice(i, 1); i--}

	}
	if(rays.length < 10) return -1;
	var resultRay = rays[Math.floor(rays.length / 2)];

	if (canvas){
		context.fillStyle = "yellow";
		context.fillRect(resultRay.start.x - 4, resultRay.start.y - 4, 8, 8);
		context.fillStyle = "pink";
		context.fillRect(resultRay.end.x - 4, resultRay.end.y - 4, 8, 8);
	}
	return Math.atan2(resultRay.end.y - resultRay.start.y, resultRay.end.x - resultRay.start.x) * (180 / Math.PI) + 90; // We add 90 to translate to positive Y-axis from X-axis.

}

function createRays(pos, r){
	var rays = [];
	for (var i = 0; i < 360; i+=2){
		var ray = {};
		ray.start = pos;
		var angle = i * (Math.PI / 180);
		var x = pos.x + r * Math.cos(angle);
		var y = pos.y + r * Math.sin(angle);
		if (canvas){
			context.fillStyle = "green";
			context.fillRect(x - 1, y - 1, 2, 2);
		}
		ray.end = new Vec2D(x, y);
		rays.push(ray);
	}
	return rays;
}

function getRayDistance(ray, min, max){
	var dist = 0;
	var color = 0;
	var unitVec = ray.end.clone().sub(ray.start).normalize();
	for (var i = min; i < max; i++){
		var pos = ray.start.clone().add(unitVec.clone().scalarMul(i));
		color = imgData[vectorToIndex(pos)];
		if (!color) break;
		dist = ray.start.distance(pos);
	}
	return dist;
}

function calculateLuminance() {
	for (var i = 0; i < imgData.length; i+=4) {
		var pos = indexToVector(i);
		var r = imgData[i], g = imgData[i+1], b = imgData[i+2];
		//imgData[i]=0; imgData[i+1]=0; imgData[i+2]=0;
		var luminance = Math.floor((r+r+b+g+g+g)/6);
		//var luminance = Math.floor((r+g+b)/3);
		if (!(imgData[i]==100 && imgData[i+1]==0 && imgData[i+2]==0)) imgData[i]=luminance; //Saves red
	}
}


function separateLuminance(threshold) {
	for (var i = 0; i < imgData.length; i+=4) {
		var pos = indexToVector(i);
		if (pos.x < areaX || pos.x > areaX + areaW || pos.y < areaY || pos.y > areaY + areaH) {
			imgData[i]=0; imgData[i+1]=0; imgData[i+2]=0;
			continue;
		}
		if ((imgData[i]==100 && imgData[i+1]==0 && imgData[i+2]==0)) continue;
		if (imgData[i] > threshold) imgData[i]=255;
		else imgData[i]=0;
	}
}

function localContrastNormalization(size){
	for (var i = 0; i < imgData.length; i+=4) {
			var pos = indexToVector(i);
			if (pos.x < areaX || pos.x > areaX + areaW || pos.y < areaY || pos.y > areaY + areaH) continue;
			var neighbors = getPixelNeighbors(pos, size);
			var sum = 0;
			for (var j = 0; j < neighbors.length; j++) {
				sum += neighbors[j];
			}
			var avg = sum / neighbors.length;
			//imgData[i+2] = imgData[i] - avg;
			if (imgData[i]  < avg - Math.floor(avg * .1)) imgData[i+2] = 0;
			else imgData[i+2] = 255;
	}
	//copy results to red channel

	for (var i = 0; i < imgData.length; i+=4){
		if (!(imgData[i]==100 && imgData[i+1]==0 && imgData[i+2]==0)) imgData[i] = imgData[i+2]; //Saves red
		imgData[i+1] = 0;
		imgData[i+2] = 0;
	}

}



function getPixelNeighbors(pos, size){  // TBD: edges not taken into consideration!
	var values = [];
	for (var j = 0; j < size; j++){ // lines
		for (var i = 0; i < size; i++){ // rows
			var x = pos.x + i - Math.floor(size / 2);
			var y = pos.y + j - Math.floor(size / 2);
			if (x == pos.x && y == pos.y) continue; // Don't include yourself
			var index = vectorToIndex(new Vec2D(x, y));
			values.push(imgData[index]);
		}
	}
	return values;
}



function separateRed(threshold) {
	var red = 0;
	for (var i = 0; i < imgData.length; i+=4) {
		var r = imgData[i], g = imgData[i+1], b = imgData[i+2];
		if (r > g + threshold && r > b + threshold) {
			imgData[i]=100;
			imgData[i+1]=0;
			imgData[i+2]=0;
			red ++;
		}
	}
	return red;
}

function getRedAmount(threshold) {
	var red = 0;
	for (var i = 0; i < imgData.length; i+=4) {
		var r = imgData[i], g = imgData[i+1], b = imgData[i+2];
		if (r > g + threshold && r > b + threshold) {
			red ++;
		}
	}
	return red;
}

function findObjects(minSize, maxSize, AABBratio){

	var foundAreas = [];

	for (var i = 0; i < imgData.length; i += channels){ // Assumes that we are interested in the first channel
		if (imgData[i] == 100 ) {

			// Discard finding if inside previously collected AABBs
			// Conversion of index to coordinates
			var p = indexToVector(i);
			// Check and continue if an object already found from current position (Uses AABB so not exact!)
			if (pointInFoundAreas(p, foundAreas)) continue;
			// We've found a possible object edge, try to get the outline

			var object = getOutlinePixels(i, maxSize);
			// Check if the object passes simple filters
			if (!object) continue;
			if (object.length < minSize || object.length > maxSize) continue; // How many points need to be found to consider the object correct?

			// Get Axis-aligned Bounding Box of the object
			var AABB = getAABB(object);

			// Add the AABB to found areas so it won't be tested again - should this be done before or after AABB validation?
			foundAreas.push(AABB);

			// Validate that AABB has correct dimensions
			if (AABBratio) {
				var testAABB = validateAABB(AABB, AABBratio);
				if (!testAABB) continue;
			}


			// Find center
			var center = findCenter(object);

			// Add result to meters array
			var meter = {id: i, center: center, edgePoints: object.length};
			meters.push(meter);
			//drawOutline(object);
		}
	}
}

function pointInFoundAreas(p, areas){
	var l = areas.length;
	for (var i = 0; i < l; i++){
		var area = areas[i];
		if (p.x >= area[0] && p.x <= area[2] && p.y >= area[1] && p.y <= area[3]) return true; //inside area
	}
	return false;
}
/*
function getDirection(box){ // Find direction of knob based on density division inside AABB area
	var x1 = box[0], y1 = box[1], x2 = box[2], y2 = box[3];
	var w = x2 - x1, h = y2 - y1;
  var direction;
	if (w > h) {
		var weight1 = getAreaPixels(x1, y1, x1 + Math.floor(w / 2), y2);
		var weight2 = getAreaPixels(x2 - Math.floor(w / 2), y1, x2, y2);
		if (weight2 > weight1) direction = "left";
		else direction = "right";
	} else {
		var weight1 = getAreaPixels(x1, y1, x2, y1 + Math.floor(h / 2));
		var weight2 = getAreaPixels(x1, y2 - Math.floor(h / 2), x2, y2);
		if (weight2 > weight1) direction = "up";
		else direction = "down";
	}
	return direction;
}
*/
function getAreaPixels(x1, y1, x2, y2){ //calculate how many active pixels are inside given box
	var w = x2 - x1;
	var h = y2 - y1;
	var total = 0;
	for (var j = 0; j < h; j++){ // lines
		for (var i = 0; i < w; i++){ // rows
			var x = x1 + i;
			var y = y1 + j;
			var index = ((width * y) + x) * 4;
			if (imgData[index]>0) {
				total++;
			}
		}
	}
	return total;
}

function getMeterAngle(pts, center){
	if (pts[0].distance2(center) > pts[1].distance2(center)) {
		return Math.atan2(pts[0].y - center.y, pts[0].x - center.x) * (180 / Math.PI) + 90; // We add 90 to translate to positive Y-axis from X-axis.
	} else {
		return Math.atan2(pts[1].y - center.y, pts[1].x - center.x) * (180 / Math.PI) + 90;
	}
}


/*
function getMeterAngle(pts, dir){
	var p1 = pts[0];
	var p2 = pts[1];
	if (dir == "up" && pts[0].y < pts[1].y) {
		p1 = pts[1]; p2 = pts[0];
	}
	if (dir == "down" && pts[0].y > pts[1].y) {
		p1 = pts[1]; p2 = pts[0];
	}
	if (dir == "left" && pts[0].x < pts[1].x) {
		p1 = pts[1]; p2 = pts[0];
	}
	if (dir == "right" && pts[0].x > pts[1].x) {
		p1 = pts[1]; p2 = pts[0];
	}
	return Math.atan2(p2.y - p1.y, p2.x - p1.x) * (180 / Math.PI) + 90; // We add 90 to translate to positive Y-axis from X-axis.
}
*/
function angleToValue(meterAngle){
	var result = (meterAngle) / 360 * 10;
	if (result < 0) result = 10 + result;
	return result;
}

function getAABB(pts){
	var minX = width, maxX = 0, minY = height, maxY = 0;
	for (var i = 0; i < pts.length; i++){
		if (pts[i].x < minX) minX = pts[i].x;
		if (pts[i].x > maxX) maxX = pts[i].x;
		if (pts[i].y < minY) minY = pts[i].y;
		if (pts[i].y > maxY) maxY = pts[i].y;
	}
	return [minX, minY, maxX, maxY];
}

function validateAABB(pts, limit){
	var w = pts[2] - pts[0];
	var h = pts[3] - pts[1];
	if (w > h ) var ratio = w / h;
	else var ratio = h / w;
	if (ratio > limit) return false;
	else return true;
}


function getCenterOffsetRatio(center, pts){
	var d1 = pts[0].distance(center);
	var d2 = pts[1].distance(center);
	if (d1 >= d2) return d1 / d2;
	else return d2 / d1;
}

function getOutlinePixels(p){
	var max = 9000; // To avoid endless loop
	var maxCounter = 0;
	var outline = [];
	outline.push(indexToVector(p)); // We already got the first pixel
	var backtrack = 7; // Assumed backtrack direction - left
	var condition = true;
	while (condition) {
		maxCounter ++;
		var neighbors = getNeighborhood(p);
		var nIndex = backtrack + 1;
		if (nIndex > 7) nIndex = 0;
		var counter = 0;
		while (counter < 8) {
			if(neighbors[nIndex].value == 100) {
				p = neighbors[nIndex].pos;
				outline.push(indexToVector(p));
				if (nIndex < 4) backtrack = nIndex + 4; else backtrack =  nIndex - 4;
				break;
			}
			nIndex ++;
			counter ++;
			if (nIndex > 7) nIndex = 0;
		}
		if (counter > 7) condition = false; // Exit if no matches found
		if (p == vectorToIndex(outline[0])) condition = false; // Exit when first pixel reached again
		if (maxCounter > max) break; // We need to give up to avoid endless loop
	}
	return outline;
}

function getNeighborhood(p){ // Builds an array of 8 pixel values surrouding a given point clockwise starting from top left corner
	var neighbors = [];
	var index = (p - channels) - (channels * width);
	neighbors[0] = {pos : index, value : imgData[index]};
	index = p - (channels * width);
	neighbors[1] = {pos : index, value : imgData[index]};
	index = (p + channels) - (channels * width);
	neighbors[2] = {pos : index, value : imgData[index]};
	index = p + channels;
	neighbors[3] = {pos : index, value : imgData[index]};
	index = (p + channels) + (channels * width);
	neighbors[4] = {pos : index, value : imgData[index]};
	index = p + (channels * width);
	neighbors[5] = {pos : index, value : imgData[index]};
	index = (p - channels)+ (channels * width);
	neighbors[6] = {pos : index, value : imgData[index]};
	index = p - channels;
	neighbors[7] = {pos : index, value : imgData[index]};
	return neighbors;
}

function findGreatestDistance(pts){ // Find greatest distance between points in array - the point closest to center is the anchor of angle)
	var l = pts.length;
	var maxD = 0, rec1 = 0, rec2 = 0;
	for (var i = 0; i < l; i++){ // first point
		for (var j = 0; j < l; j++) { // second point
			if (j != i) { // Don't compare point with itself
				var d = pts[i].distance2(pts[j]); // we don't need square root for comparison
				if (d > maxD) {
					maxD = d; // Save also the points that gave the recorded distance
					rec1 = pts[i];
					rec2 = pts[j];
				}
			}
		}
	}
	return [rec1, rec2];
}

// DEBUG DRAWING FUNCTIONS

function drawAABB(pts){
	context.lineWidth = 1;
	context.strokeStyle = "blue";
	context.beginPath();
	context.rect(pts[0], pts[1], pts[2] - pts[0], pts[3] - pts[1]);
	context.stroke();
}

function drawCenter(center)	{
	context.beginPath();
	context.arc(center.x, center.y, 5, 0, 2 * Math.PI, false);
	context.fillStyle = 'green';
	context.fill();
}

function drawOutline(outline){
	var source = sourceImageData.data;
	//console.log("points found : " + outline.length);
	for (var i = 0; i < outline.length; i++){
		source[outline[i] + 1]= 255;
	}
}

function drawMeters(meters){
	for (var i = 0; i < meters.length; i ++){
		//console.log(meters[i].center.x);
		context.fillStyle = "blue";
		context.fillRect(meters[i].center.x - 2, meters[i].center.y - 2, 4, 4);

	}
}

function drawValues(places){
	context.font="14px Arial";
	context.fillStyle = "green";
	if(meters[0] && meters[0].value)
		context.fillText("A " + parseFloat(Math.round(meters[0].value * 100) / 100).toFixed(places) ,10,20);
	if(meters[1] && meters[1].value)
		context.fillText("B " + parseFloat(Math.round(meters[1].value * 100) / 100).toFixed(places)  ,10,40);
	if(meters[2] && meters[2].value)
		context.fillText("C " + parseFloat(Math.round(meters[2].value * 100) / 100).toFixed(places)  ,10,60);
	if(meters[3] && meters[3].value)
		context.fillText("D " + parseFloat(Math.round(meters[3].value * 100) / 100).toFixed(places)  ,10,80);
}

function drawRedPixels(){
	context.fillStyle = "red";
	for (var i = 0, len = width * height * channels; i < len; i += channels) {
		if (imgData[i] == 100) {
			var p = indexToVector(i);
			context.fillRect(p.x, p.y, 1, 1);
		}
	}
}

function drawBlackPixels(){
	context.fillStyle = "black";
	for (var i = 0, len = width * height * channels; i < len; i += channels) {
		if (imgData[i] == 0) {
			var p = indexToVector(i);
			context.fillRect(p.x, p.y, 1, 1);
		}
	}
}

// MORE HELPER FUNCTIONS

function findCenter(pts){ //finds centroid of points
	var l = pts.length;
	var totalX = 0;
	var totalY = 0;
	for (var i = 0; i < l; i++){
		totalX += pts[i].x;
		totalY += pts[i].y;
	}
	var averageX = Math.floor(totalX / l);
	var averageY = Math.floor(totalY / l);
	return new Vec2D(averageX, averageY);
}

function getMaxWidths(){ // Not currently used - gets the widest solid line of active pixels from the image
	var maxW = 1;
	var inside = false;
	var start = 0;
	for (var i = 0; i < imgData.length; i += 4){
		var r = imgData[i];
		if (r > 0 && inside == false) {
			inside = true;
			start = i;
		} else if ( r == 0 && inside == true) {
			var width = i / 4 - start / 4;
			if (width > maxW) maxW = width;
			inside = false;
		}
	}
	//console.log("maxW : " + maxW);
	return maxW;
}

function removeChannel(channel) { // Not currently used - sets a given color channel to zeros
	for (var i = 0; i < imgData.length; i+=4) {
		imgData[i+channel]=0;
	}
}


function findCenterOfObject(pts, meterPts){ // Find greatest distance of edge points from direction line
	var x1 = meterPts[0].x;
	var y1 = meterPts[0].y;
	var x2 = meterPts[1].x;
	var y2 = meterPts[1].y;

	var l = pts.length;
	var maxD1 = 0, maxD2 = 0, rec1X = 0, rec1Y = 0, rec2X = 0, rec2Y = 0, dPoint1 = null, dPoint2 = null;
	for (var i = 0; i < l; i++){ // first point
		var p1 = pts[i];
		var signtest = side(meterPts[0], meterPts[1], p1);
		var x = p1.x;
		var y = p1.y;
		var d = getDistanceFromLine(x, y, x1, y1, x2, y2);
		if (signtest > 0 && d[0] > maxD1) {
				maxD1 = d[0]; // Save
				rec1X = d[1];
				rec1Y = d[2];
				dPoint1 = p1;
			}
		if (signtest < 0 && d[0] > maxD2) {
				maxD2 = d[0]; // Save
				rec2X = d[1];
				rec2Y = d[2];
				dPoint2 = p1;
			}
		}

	if (maxD2 >= maxD1) var symmetryRatio = maxD2 / maxD1;
	else var symmetryRatio = maxD1 / maxD2;

	var recX = (rec1X + rec2X) / 2;
	var recY = (rec1Y + rec2Y) / 2;

	return {center: new Vec2D(recX, recY), symmetryRatio: symmetryRatio, dPoint1 : dPoint1, dPoint2 : dPoint2};
}

function side(a, b, c){
	return ( ((b.x - a.x)*(c.y - a.y) - (b.y - a.y)*(c.x - a.x)) ) > 0 ? 1 : -1;
}


// Distance of point from line segment
function getDistanceFromLine(x, y, x1, y1, x2, y2) {
	var A = x - x1, B = y - y1, C = x2 - x1, D = y2 - y1;
	var dot = A * C + B * D;
	var len_sq = C * C + D * D;
	var param = -1;
	if (len_sq != 0) param = dot / len_sq; // Check for 0
	var xx, yy;
	if (param < 0) {xx = x1; yy = y1;}
	else if (param > 1) {xx = x2; yy = y2;}
	else { xx = x1 + param * C; yy = y1 + param * D;}
	var dx = x - xx; var dy = y - yy;
	return [Math.sqrt(dx * dx + dy * dy), xx, yy];
}


// 2D VECTOR CLASS

function indexToVector(i) {
	var x = (i / channels) % width;
	var y =  Math.floor((i / channels) / width);
	return new Vec2D(x, y);
}

function vectorToIndex(p){
	var i = Math.floor(p.x) * channels + Math.floor(p.y) * channels * width;
	return i;
}

var Vec2D = function(x, y) {
	this.x = x;
	this.y = y;
};

Vec2D.prototype.clone = function() {
	return new Vec2D(this.x, this.y);
};

Vec2D.prototype.clear = function() {
	this.x = 0; this.y = 0;
	return this;
};

Vec2D.prototype.magnitude = function() {
	return Math.sqrt(this.x * this.x + this.y * this.y);
};

Vec2D.prototype.magnitude2 = function() {
	return this.x * this.x + this.y * this.y;
};

Vec2D.prototype.scale = function(s) {
	this.x *= s; this.y *= s;
	return this;
};

Vec2D.prototype.scalarMul = function(s) {
	return this.scale(s);
};

Vec2D.prototype.scalarDiv = function(s) {
	this.x /= s; this.y /= s;
	return this;
};

Vec2D.prototype.invert = function() {
	this.x = -this.x; this.y = -this.y;
	return this;
};

Vec2D.prototype.perp = function() {
    return new Vec2D(-this.y, this.x);
};

Vec2D.prototype.normalize = function() {
	return this.scale(1 / this.magnitude());
};

Vec2D.prototype.add = function(v) {
	this.x += v.x; this.y += v.y;
	return this;
};

Vec2D.prototype.sub = function(v) {
	this.x -= v.x; this.y -= v.y;
	return this;
};

Vec2D.prototype.rotate = function(a) {
	var cos = Math.cos(a), sin = Math.sin(a);
	var tempX = this.x * cos - this.y * sin;
	var tempY = this.y * cos + this.x * sin;
	this.x = tempX; this.y = tempY;
	return this;
};

Vec2D.prototype.rotatePivot = function(pivot, a) {
	return this.sub(pivot).rotate(a).add(pivot);
};

Vec2D.prototype.sameAs = function(v) {
	return this.x == v.x && this.y == v.y;
};

Vec2D.prototype.distance = function(v) {
	var dx = this.x - v.x, dy = this.y - v.y;
	return Math.sqrt(dx * dx + dy * dy);
};

Vec2D.prototype.distance2 = function(v) {
	var dx = this.x - v.x, dy = this.y - v.y;
	return dx * dx + dy * dy;
};

Vec2D.prototype.sum = function(v) {
	return new Vec2D(this.x + v.x, this.y + v.y);
};

Vec2D.prototype.difference = function(v) {
	return new Vec2D(this.x - v.x, this.y - v.y);
};

Vec2D.prototype.dot = function(v) {
	return this.x * v.x + this.y * v.y;
};

Vec2D.prototype.cross = function (v) {
	return this.x * v.y - this.y * v.x;
};

Vec2D.prototype.clamp = function(v1, v2) {
	var maxX = Math.max(v1.x, v2.x);
	var maxY = Math.max(v1.y, v2.y);
	var minX = Math.min(v1.x, v2.x);
	var minY = Math.min(v1.y, v2.y);
	this.x = Math.max(minX, Math.min(maxX, this.x));
	this.y = Math.max(minY, Math.min(maxY, this.y));
	return this;
};

Vec2D.prototype.limit = function(max) {
	var l = this.magnitude2();
    if( ( l > max * max ) && ( l > 0 ) ) {
		var ratio = max / Math.sqrt( l );
		this.x *= ratio;
		this.y *= ratio;
	}
}

Vec2D.prototype.lerp = function(that,t) {
	return new Vec2D(this.x+(that.x-this.x)*t,this.y+(that.y-this.y)*t);
} // Linear interpolation

Vec2D.prototype.min = function(that){
	return new Vec2D(Math.min(this.x,that.x),Math.min(this.y,that.y));
}

Vec2D.prototype.max = function(that){
	return new Vec2D(Math.max(this.x,that.x),Math.max(this.y,that.y));
}

Vec2D.prototype.lte = function(that){
	return(this.x<=that.x&&this.y<=that.y);
}

Vec2D.prototype.gte = function(that){
	return(this.x>=that.x&&this.y>=that.y);
}






//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/long-pointer-reader/index.js
// module id = 855
// module chunks = 0